import {Injectable} from '@angular/core';
import {JQueryStatic} from 'jquery';
import {Observable, Observer} from 'rxjs/Rx';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie';
import {Usuario} from '../model/usuario';

declare var $: JQueryStatic;

@Injectable()
export class ModalService {

    prefixo: string = '';
    titulo: string = '';
    mensagem: string = '';
    fechar: string = '';
    dadosGeradosObserver: Observer<any> = null;

    constructor(private router: Router, private cookieService: CookieService) {
    }

    exibirMensagem(titulo: string, mensagem: string, fechar: string) {

        let usuario = <Usuario>this.cookieService.getObject('usuarioCadastro');
        if (usuario == null) {
            return;
        }

        this.titulo = titulo;
        this.mensagem = mensagem;
        this.fechar = fechar;

        this.router.navigate(['',
            {outlets: {'modal': null}}]
        );

        let options = {backdrop: 'static'};
        $('#modal').modal(options);
    }

    abrirPaginaModal(caminho: string, parametros: any, queryParametros: any, titulo: string, fechar: string): Observable<any> {

        let subscription: Observable<any> = Observable.create(observer => this.dadosGeradosObserver = observer);

        this.titulo = titulo;
        this.mensagem = '';
        this.fechar = fechar;

        this.router.navigate([
                {outlets: {'modal': [caminho, parametros]}}],
            {queryParams: queryParametros}
        );

        let options = {backdrop: 'static'};
        $('#modal').modal(options);

        return subscription;
    }

    fecharPaginaModal() {
        this.router.navigate([this.prefixo, {outlets: {'modal': null}}]);
        // this.globalService.mudarNavegacao("primary");

        if (this.dadosGeradosObserver != null) {
            this.dadosGeradosObserver.complete();
            this.dadosGeradosObserver = null;
        }

        $('#modal').modal('hide');
        $('.modal-backdrop').each(function () {
            $(this).remove();
        });
    }

    incluirDadosGerados(dados: any) {

        if (this.dadosGeradosObserver != null) {
            this.dadosGeradosObserver.next(dados);
        }
    }

}



// WEBPACK FOOTER //
// ./src/service/modal.service.ts